module.exports = __webpack_public_path__ + "img/404.48c17f60.svg";